// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".device-settings .device-settings-title[data-v-2686f932] {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 27px;\n  letter-spacing: 0px;\n  opacity: 0.9;\n  color: var(--v-white-base);\n}\n.device-settings .device-content[data-v-2686f932] {\n  border-bottom: 1px solid var(--v-gray-40) !important;\n  display: flex;\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
